<template>
  <transition name="fade">
    <div class="tooltip" v-show="show">
      <button @click="update_selected_postcode(null)">
        <svg  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
      <h6 class="tooltip__title">
        {{ name }}^ 
        <span class="tooltip__subtitle">
          {{ postcode }}
        </span>
      </h6>
      <p class="tooltip__text" v-for="t in tooltip_text" 
        :key="`${postcode}-${t.key}`"
      >
        <span class="tooltip__key">{{t.key}}:&nbsp;</span>
        <span class="tooltip__value">{{t.value}}</span>
      </p>
      <p class="tooltip__note">^This postcode may contain</p>
      <p class="tooltip__note">other locality names</p>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { format } from 'd3-format'

export default {
  computed: {
    show () {
      if (this.currentView === 'landing') {
        return false
      }
      return this.highlightedPostcode
    },
    name () {
      if (this.highlightedPostcode && this.highlightedPostcode.postcode_name) {
        return this.highlightedPostcode.postcode_name
      } else {
        return undefined
      }
    },
    postcode () {
      if (this.highlightedPostcode && this.highlightedPostcode.postcode) {
        return this.highlightedPostcode.postcode
      } else {
        return undefined
      }
    },
    ...mapState([ 
      'currentView', 
      'data'
    ]),
    ...mapGetters([
      'highlightedPostcode'
    ]),
    tooltip_text () {

      if (!this.highlightedPostcode) return []

      let d = this.highlightedPostcode
      
      switch(this.currentView) {
        case 'intro':
          return [
              {
                key: 'Region',
                value: d.region
              }
            ]
        case 'first':
          return [
              {
                key: 'Avg time to CBD',
                value: format('.0f')(d.avg_pt_time) + 'min'
              }
            ]
        case 'second':
          return [
              {
                key: 'Primary mode',
                value: d.primary_mode_driving
              }
            ]
        case 'third':
          return [
              {
                key: 'Primary mode',
                value: d.primary_mode
              }
            ]
        case 'fourth':
          return [
              {
                key: 'Avg time to CBD',
                value: format('.0f')(d.avg_pt_time) + 'min'
              }
            ]
        case 'fifth':
        case 'seventh':
          return [
              {
                key: 'Avg rent',
                value: '$' + format('.0f')(d.avg_rent) + ' pw'
              }
            ]
        case 'sixth':
          return [
              {
                key: 'Avg rent',
                value: '$' + format('.0f')(d.avg_rent) + ' pw'
              },
              {
                key: 'Avg time to CBD',
                value: format('.0f')(d.avg_pt_time) + 'min'
              }
            ]
        default:
          return []
      }

    }
  },
  methods: {
    ...mapMutations([ 'update_selected_postcode' ]),
  }
}
</script>

<style scoped>

.tooltip {
  position: absolute;
  text-align: right;
  z-index: 100;
  font-family: "Heebo", sans-serif;
  font-size: 12px;
  /* visibility: hidden; */
  top: 10px;
  right: 17px;
  background-color: rgba(255,255,255,0.6);
  padding: 8px 12px;
}.tooltip__title {
  color: rgb(48,44,44);
  font-size: 14px;
  margin: 0;
}.tooltip__subtitle {
  font-weight: 400;
}
.tooltip__text {
  margin: 0;
  text-transform: capitalize;
}.tooltip__key {
  font-weight: 100;
  text-transform: capitalize;
  /* margin-right: .5em; */
}.tooltip__note{
  line-height:1.0;
  font-size: 8px;
  margin: 0;
  color:rgb(170, 170, 170);
}

</style>
